
export function flatten(array, depth = 1, result = []) {
  let index = -1;
  const length = array.length;

  while (++index < length) {
    const value = array[index];
    if (depth > 0 && Array.isArray(value)) {
      if (depth > 0) {
        // Recursively flatten arrays (susceptible to call stack limits).
        flatten(value, depth - 1, result);
      } else {
        result.push(value);
      }
    } else {
      result[result.length] = value;
    }
  }
  return result;
}

export function uniqPrimitiveValues(array: Array<any>) {
  return [...new Set(array)];
}
